module.exports = __webpack_public_path__ + "static/media/map2@2x.844e59e9.png";